import { Components, Theme } from '@mui/material/styles';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

export const flowRadio: Components<Theme>['MuiRadio'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      padding: '0',
      borderRadius: '200px',
      // default unselected color
      '&, &:hover': {
        color: theme.palette.text.primary,
      },
      // 'primary' and other unsupported variants style ('success')
      '&.Mui-checked': {
        '&, &:hover': {
          color: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
        },
      },
      // focus style
      ...getFocusRingStyle(theme, false, '0px'),
      // color variants
      ...(ownerState.color === 'secondary' && {
        '&.Mui-checked': {
          '&, &:hover': {
            color: theme.palette.secondary.main,
          },
        },
      }),
      ...(ownerState.color === 'error' && {
        '&, &.Mui-checked': {
          '&, &:hover': {
            color: theme.palette.error.main,
          },
        },
      }),
      // disabled style
      '&.Mui-disabled': {
        color: theme.palette.disabled.tertiary,
      },
    }),
  },
};
